// better-auth browser client — single instance for the SPA. No
// organizationClient : the server refuses /api/auth/organization/** (the
// app manages agencies / offices through its own API).
//
// The auth API is served by THIS app's Worker under /api/auth/* (see
// src/server/index.mjs), so no cross-origin base is needed ; VITE_AUTH_BASE_URL
// stays supported for topology A setups (auth.<rootDomain>).

import { createAuthClient } from 'better-auth/react';
import { magicLinkClient } from 'better-auth/client/plugins';
import { passkeyClient } from '@better-auth/passkey/client';

export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_AUTH_BASE_URL || undefined,
  // better-fetch (the client's transport) does NOT send cookies by default,
  // so every session read came back empty on a fresh load even with a valid
  // cookie — the app bounced authenticated users to /login on refresh.
  // `credentials: 'include'` makes the session cookie ride along.
  fetchOptions: { credentials: 'include' },
  plugins: [
    magicLinkClient(),
    passkeyClient(),
  ],
});

export const { useSession: useAuthSession, signIn, signOut } = authClient;
